<div [class]="status.class">
  @if (status.icon) {
  <i [class]="status.icon"></i>
  }
  <div>{{ status.text }}</div>
</div>
